/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { useState } from 'react';

export interface ISignUpCheckbox {
    id?: string;
    name: string;
    text?: any;
    className?: string;
    onChange?: undefined;
    ariaLabel?: string;
}

export const SignUpKeepUpCheckbox: React.FC<ISignUpCheckbox> = ({ id, className, text, name, onChange }) => {
    const [textValue, setValue] = useState('false');
    const _change = (e: any) => {
        setValue(textValue === 'true' ? 'false' : 'true');
    };
    return (
        <div style={{ display: 'table' }} className='checkbox-container'>
            <label>
                <input
                    type='checkbox'
                    id={id}
                    value={textValue}
                    name={name}
                    onChange={_change}
                    style={{ display: 'table-cell', verticalAlign: 'bottom' }}
                />
                <span className='checkmark'></span>
                {text && <div style={{ display: 'table-cell' }} dangerouslySetInnerHTML={{ __html: text }} />}
            </label>
        </div>
    );
};

export const SignUpTermsAndConditionsCheckbox: React.FC<ISignUpCheckbox> = ({ id, className, text, name, ariaLabel }) => {
    const [textValue, setValue] = useState('');
    const _change = () => {
        const updatedValue: any = textValue === 'true' ? '' : 'true';
        const isChecked = updatedValue === 'true';
        const e: any = document.getElementById('continue');
        if (e) {
            e.disabled = !isChecked;
        }
        setValue(updatedValue);
    };
    return (
        <div style={{ display: 'table' }} className='checkbox-container'>
            <label>
                <input
                    type='checkbox'
                    id={id}
                    value={textValue}
                    name={name}
                    aria-label={ariaLabel}
                    onChange={_change}
                    style={{ display: 'table-cell', verticalAlign: 'bottom' }}
                />
                <span className='checkmark'></span>
                {text && <div style={{ display: 'table-cell' }} dangerouslySetInnerHTML={{ __html: text }} />}
            </label>
        </div>
    );
};
